/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Payments {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Create or retrieve a PaymentIntent and generate a Mercado Pago checkout preference. Calculates pass-through platform fee and net payout splits automatically.
   *
   * @tags Payments
   * @name CreateCheckout
   * @summary Create Checkout
   * @request POST:/api/payments/checkout
   * @secure
   */
  createCheckout = (data, params = {}) =>
    this.http.request({
      path: `/api/payments/checkout`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve PaymentIntent with authorization check and pass-through split scoping.
   *
   * @tags Payments
   * @name GetPaymentIntent
   * @summary Get Payment Intent
   * @request GET:/api/payments/intents/{intent_id}
   * @secure
   */
  getPaymentIntent = (intentId, params = {}) =>
    this.http.request({
      path: `/api/payments/intents/${intentId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List payment intents with filtering.
   *
   * @tags Payments
   * @name ListPaymentIntents
   * @summary List Payment Intents
   * @request GET:/api/payments/intents
   * @secure
   */
  listPaymentIntents = (query, params = {}) =>
    this.http.request({
      path: `/api/payments/intents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Mercado Pago IPN & Webhook Receiver. Processes payment status, settles splits, and triggers rental reconciliation. Supports both POST webhooks and GET/POST IPN query parameter notifications.
   *
   * @tags Payments
   * @name MercadopagoWebhookGet
   * @summary Mercadopago Webhook
   * @request GET:/api/payments/webhooks/mercadopago
   */
  mercadopagoWebhookGet = (params = {}) =>
    this.http.request({
      path: `/api/payments/webhooks/mercadopago`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Mercado Pago IPN & Webhook Receiver. Processes payment status, settles splits, and triggers rental reconciliation. Supports both POST webhooks and GET/POST IPN query parameter notifications.
   *
   * @tags Payments
   * @name MercadopagoWebhookPost
   * @summary Mercadopago Webhook
   * @request POST:/api/payments/webhooks/mercadopago
   */
  mercadopagoWebhookPost = (params = {}) =>
    this.http.request({
      path: `/api/payments/webhooks/mercadopago`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Generate Mercado Pago OAuth Connect authorization URL for pass-through onboarding.
   *
   * @tags Payments
   * @name ConnectMercadopago
   * @summary Connect Mercadopago
   * @request GET:/api/payments/connect/mercadopago
   */
  connectMercadopago = (params = {}) =>
    this.http.request({
      path: `/api/payments/connect/mercadopago`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Exchange OAuth authorization code for connected Mercado Pago account credentials.
   *
   * @tags Payments
   * @name ConnectMercadopagoCallback
   * @summary Connect Mercadopago Callback
   * @request POST:/api/payments/connect/mercadopago/callback
   * @secure
   */
  connectMercadopagoCallback = (data, params = {}) =>
    this.http.request({
      path: `/api/payments/connect/mercadopago/callback`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List connected gateway accounts for current user.
   *
   * @tags Payments
   * @name ListConnectedAccounts
   * @summary List Connected Accounts
   * @request GET:/api/payments/accounts
   * @secure
   */
  listConnectedAccounts = (params = {}) =>
    this.http.request({
      path: `/api/payments/accounts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Generate a Stripe SetupIntent allowing clients to collect payment methods without handling raw credentials. Automatically retrieves or creates the corresponding Stripe Customer.
   *
   * @tags Payments
   * @name CreateStripeSetupIntent
   * @summary Create Stripe Setup Intent
   * @request POST:/api/payments/stripe/setup-intent
   * @secure
   */
  createStripeSetupIntent = (data, params = {}) =>
    this.http.request({
      path: `/api/payments/stripe/setup-intent`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Attach and persist a Stripe payment method (Card or Direct Debit) for the current user or organization.
   *
   * @tags Payments
   * @name AttachStripePaymentMethod
   * @summary Attach Stripe Payment Method
   * @request POST:/api/payments/stripe/payment-methods
   * @secure
   */
  attachStripePaymentMethod = (data, params = {}) =>
    this.http.request({
      path: `/api/payments/stripe/payment-methods`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List active payment methods. Organization methods require ADMIN authority; all other queries scope strictly to current_user.id.
   *
   * @tags Payments
   * @name ListStripePaymentMethods
   * @summary List Stripe Payment Methods
   * @request GET:/api/payments/stripe/payment-methods
   * @secure
   */
  listStripePaymentMethods = (query, params = {}) =>
    this.http.request({
      path: `/api/payments/stripe/payment-methods`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List active payment methods. Organization methods require ADMIN authority; all other queries scope strictly to current_user.id.
   *
   * @tags Payments
   * @name ListStripePaymentMethods2
   * @summary List Stripe Payment Methods
   * @request GET:/api/payments/methods/saved
   * @originalName listStripePaymentMethods
   * @duplicate
   * @secure
   */
  listStripePaymentMethods2 = (query, params = {}) =>
    this.http.request({
      path: `/api/payments/methods/saved`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Set a payment method as the default.
   *
   * @tags Payments
   * @name SetDefaultPaymentMethod
   * @summary Set Default Payment Method
   * @request POST:/api/payments/stripe/payment-methods/{pm_id}/default
   * @secure
   */
  setDefaultPaymentMethod = (pmId, params = {}) =>
    this.http.request({
      path: `/api/payments/stripe/payment-methods/${pmId}/default`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Detach and delete payment method.
   *
   * @tags Payments
   * @name DeleteStripePaymentMethod
   * @summary Delete Stripe Payment Method
   * @request DELETE:/api/payments/stripe/payment-methods/{pm_id}
   * @secure
   */
  deleteStripePaymentMethod = (pmId, params = {}) =>
    this.http.request({
      path: `/api/payments/stripe/payment-methods/${pmId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Receive Stripe Billing Webhooks (invoice.paid, invoice.payment_failed, customer.subscription.*). Updates OrganizationSubscription lifecycle state and records idempotent transaction ledger rows. Supports signature verification with test mock bypass.
   *
   * @tags Payments
   * @name StripeBillingWebhook
   * @summary Stripe Billing Webhook
   * @request POST:/api/payments/webhooks/stripe
   */
  stripeBillingWebhook = (params = {}) =>
    this.http.request({
      path: `/api/payments/webhooks/stripe`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Query general ledger entries for the authenticated organization.
   *
   * @tags Payments
   * @name ListLedgerEntries
   * @summary List Ledger Entries
   * @request GET:/api/payments/ledger/entries
   * @secure
   */
  listLedgerEntries = (query, params = {}) =>
    this.http.request({
      path: `/api/payments/ledger/entries`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve the real-time running balance for an accounting account.
   *
   * @tags Payments
   * @name GetAccountBalance
   * @summary Get Account Balance
   * @request GET:/api/payments/accounts/{account_id}/balance
   * @secure
   */
  getAccountBalance = (accountId, params = {}) =>
    this.http.request({
      path: `/api/payments/accounts/${accountId}/balance`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
